<template>

<svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M86.8747 26.2593L75.6154 15L36.2997 54.3157L35.3747 66.5L47.559 65.5751L86.8747 26.2593Z" stroke="black" stroke-width="4"/>
<path d="M66.6039 24.0115L77.8632 35.2708" stroke="black" stroke-width="4" stroke-linecap="round"/>
<path d="M40.4225 29.1539C26.6426 29.1539 19 29.1539 19 29.1539V84H73.8461V60.0157" stroke="black" stroke-width="4" stroke-linecap="square"/>
</svg>

</template>
